import { AboutOAI } from "./AboutOAI";

import { BenefitInsuranceTemplate } from "../../../types";
import { OAI_KEY, PLAN_DETAILS } from "../../../utils/constants";

const { monthlyPremiumFormatted, name } = PLAN_DETAILS[OAI_KEY];

export const getOAIBenefitDetails = (): BenefitInsuranceTemplate => {
  return {
    slug: OAI_KEY,
    title: name,
    costDescription: (
      <>
        <b>Premium Cost:</b> {monthlyPremiumFormatted} of your non-reimbursable
        gross earnings.
        <br /> <br />
        <b>Automatic Deductions:</b> The premium is automatically deducted from
        each payment you receive through Wingspan. If you don't get paid, you
        aren't charged.
      </>
    ),
    about: <AboutOAI />,
    regionConfig: {
      mode: "allowlist",
      countries: ["US"],
      stateOverrides: {
        US: {
          mode: "blocklist",
          states: ["OH", "ND", "WA", "WY"]
        }
      }
    }
  };
};
